import React, { Component } from 'react'
import { TABLA_DETALLE_POR_CONDICION_LINEA_4 } from '../../../../../config/tables'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'

export class TablaDetallePorCondicionLinea4View extends Component {
  render () {
    return (
      <MuiTable id={TABLA_DETALLE_POR_CONDICION_LINEA_4} />
    )
  }
}
